export const columns = {
    ELECTION_TYPE: 'electionType',
    NUMBER_OF_ELECTIONS: 'numberOfElections',
    PERCENT_OF_TOTAL_ELECTIONS: 'percentOfTotalElections'
};
